module.exports = __webpack_public_path__ + "media/images/icons/material/export-23c37d4c45c6351492df52e48c2f65f6.svg";